import React, { useEffect, useState } from "react";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader.jsx";
import { BeforeLoginHeader } from "../../../stories/BeforeLoginHeader/BeforeLoginHeader.jsx";
import { Radio } from "../../../stories/Radio/Radio";
import { Input } from "../../../stories/Input/Input.jsx";
import { Footer } from "../../../stories/Footer/Footer.jsx";
import { Row, Col, Container } from "react-bootstrap";
import classes from "./ContactUs.module.css";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { HeadingBg, faqIcon } from "../../../constant/imagePath";
import { DropDown } from "../../../stories/DropDown/DropDown.jsx";
import { TextArea } from "../../../stories/TextArea/TextArea.jsx";
import { Button } from "../../../stories/Button/Button.jsx";
import { CommonQuestions } from "../../../stories/CommonQuestions/CommonQuestions";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook.js";
import ContactUsMobile from "./ContactUsMobile.jsx";

const ContactUsDesktop = ({ SubmitForm }) => {
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [topic, setTopic] = useState();
  const [message, setMessage] = useState();
  const [role, setRole] = useState("Student");
  return (
    <div className={classes.contactUs}>
      <Container fluid className="p-0 ">
        <Row className={classes.mainContent}>
          <div className={classes.header}>
            <AfterLoginHeader />
          </div>
          <Col lg={7} className={classes.formCol}>
            <h2
              className={classes.formHeading}
              style={{ ...Fonts.h2, color: Colors.neutralShadesOfNero }}
            >
              <span>
                {" "}
                Contact
                <img src={HeadingBg} />
              </span>{" "}
              Us
            </h2>
            {/* Form Row */}
            <Row>
              <Col lg={6} className={classes.mb32}>
                <p
                  style={{
                    ...Fonts.h7,
                    lineHeight: "24px",
                    fontFamily: "inter-600",
                    color: Colors.neutralShadesOfNero,
                    letterSpacing: "-1%",
                  }}
                >
                  Your role
                </p>
                <div className={classes.roleRadios}>
                  <Radio
                    label="Student"
                    value={role}
                    setValue={() => setRole("Student")}
                  />
                  <Radio
                    label="Coach"
                    value={role}
                    setValue={() => setRole("Coach")}
                  />
                </div>
              </Col>
              <Col lg={6} />
              <Col lg={6} className={classes.mb32}>
                <Input
                  label={"First Name"}
                  state={firstName}
                  setter={setFirstName}
                  type="text"
                  placeholder={""}
                />
              </Col>
              <Col lg={6} className={classes.mb32}>
                <Input
                  label={"Last Name"}
                  state={lastName}
                  setter={setLastName}
                  type="text"
                  placeholder={""}
                />
              </Col>
              <Col lg={6} className={classes.mb32}>
                <Input
                  label={"Email"}
                  state={email}
                  setter={setEmail}
                  type="text"
                  placeholder={""}
                />
              </Col>
              <Col lg={6} className={classes.mb32}>
                <DropDown
                  label={"Topic"}
                  state={topic}
                  setter={setTopic}
                  placeholder={"Select One"}
                  options={[
                    {
                      value: "I have a question about my profile",
                      label: "I have a question about my profile",
                    },
                    {
                      value: "I had problems with the lesson",
                      label: "I had problems with the lesson",
                    },
                    {
                      value: "I have a payment issue",
                      label: "I have a payment issue",
                    },
                    {
                      value: "I’m trying to find a coach",
                      label: "I’m trying to find a coach",
                    },
                    {
                      value: "I have a bug to report",
                      label: "I have a bug to report",
                    },
                    { value: "Other", label: "Other" },
                  ]}
                />
              </Col>
              <Col lg={12} className={classes.mb32}>
                <TextArea
                  label={"Your Message"}
                  state={message}
                  setter={setMessage}
                  textAreaStyle={{ minHeight: "164px", maxHeight: "164px" }}
                  placeholder={""}
                />
              </Col>
              <Col lg={12}>
                <Button
                  label={"Get in touch"}
                  primary={true}
                  size={"Large"}
                  customStyle={{
                    //   padding: "12px 32px 12px 32px",
                    height: "56px",
                    width: "158px",
                  }}
                  onClick={() => {
                    SubmitForm({
                      email,
                      topic,
                      message,
                      role,
                      firstName,
                      lastName,
                    });
                  }}
                />
              </Col>
            </Row>
          </Col>
          <Col
            lg={5}
            className={classes.faqCol}
            style={{
              backgroundColor: Colors.neutralShadesOfWhiteSmoke,
            }}
          >
            <div>
              <img src={faqIcon} className={classes.faqIcon} />
              <h4 style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero }}>
                FAQ
              </h4>
              <p
                className={classes.faqTagline}
                style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
              >
                Here are some of our more frequently asked questions and the
                quick, straight to the point, answers.
              </p>
              <CommonQuestions
                customStyle={{
                  backgroundColor: Colors.neutralShadesOfWhiteSmoke,
                }}
                data={[
                  {
                    title: "Can I bring more than one person?",
                    description:
                      "For most people, a weekly tennis lesson is about the right number to maintain their development, as long as they are playing at least once per week on top of this.",
                  },
                  {
                    title: "Are there any other fees?",
                    description:
                      "For most people, a weekly tennis lesson is about the right number to maintain their development, as long as they are playing at least once per week on top of this.",
                  },
                  {
                    title: "Can we speak before the lesson?",
                    description:
                      "For most people, a weekly tennis lesson is about the right number to maintain their development, as long as they are playing at least once per week on top of this.",
                  },
                  {
                    title: "Do you offer a free trial lesson?",
                    description:
                      "For most people, a weekly tennis lesson is about the right number to maintain their development, as long as they are playing at least once per week on top of this.",
                  },
                ]}
              />
              <p
                className={classes.needHelp}
                style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
              >
                Need Help? Visit our{" "}
                <span style={{ ...Fonts.p1, color: Colors.mainCeruleanBlue }}>
                  Help Center
                </span>
              </p>
            </div>
          </Col>
          <Col className={classes.footerCol}>
            <Footer className={classes.container} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

function ContactUs() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, [window.innerWidth]);

  const HandleSubmitForm = (e) => {
    console.log(e);
  };

  return (
    <div>
      {isMobile ? (
        <ContactUsMobile SubmitForm={HandleSubmitForm} />
      ) : (
        <ContactUsDesktop SubmitForm={HandleSubmitForm} />
      )}
    </div>
  );
}

export default ContactUs;
